export const getHardSeasonStart = (season: string): Date | undefined => {
  const match = /\d{4}/.exec(season);
  return match ? new Date(+match[0] - 1, 0, 1) : undefined;
};

export const getHardSeasonEnd = (season: string): Date | undefined => {
  const match = /\d{4}$/.exec(season);
  return match ? new Date(+match[0] + 1, 11, 31) : undefined;
};

export const getSoftSeasonStart = (season: string): Date | undefined => {
  const match = /\d{4}/.exec(season);
  return match ? new Date(+match[0], 0, 1) : undefined;
};

export const getSoftSeasonEnd = (season: string): Date | undefined => {
  const match = /\d{4}$/.exec(season);
  return match ? new Date(+match[0], 11, 31) : undefined;
};
